// src/features/signup/signupSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

export const addDesignLink = createAsyncThunk(
  "design/ ",
  async ({id, design_link}) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.post(
        `/add-design-link/${id}`,
        { design_link: design_link },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error(
        "Error adding design link:",
        error.response?.data?.message || error.message
      );
      throw error;
    }
  }
);

const uploadDesignSlice = createSlice({
  name: "design",
  initialState: {
    designlink: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addDesignLink.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addDesignLink.fulfilled, (state, action) => {
        state.isLoading = false;
        state.designlink = action.payload; // Store only user data
      })
      .addCase(addDesignLink.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default uploadDesignSlice.reducer;
